import React, { useEffect, useRef, useState } from "react";
import { FiSearch, FiX } from "react-icons/fi";

export default function ExpandableSearch({
  value,
  onChange,
  placeholder = "Search records",
  label = "Search",
  className = "",
}) {
  const [open, setOpen] = useState(Boolean(value));
  const inputRef = useRef(null);

  useEffect(() => {
    if (open) inputRef.current?.focus();
  }, [open]);

  const close = () => {
    onChange("");
    setOpen(false);
  };

  return (
    <div className={`flex min-w-0 justify-end ${className}`}>
      <div
        className={`flex h-10 items-center overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-[width] duration-200 ${
          open ? "w-full sm:w-72" : "w-10"
        }`}
      >
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="inline-flex h-10 w-10 shrink-0 items-center justify-center text-slate-600 hover:text-[#1234CD]"
          aria-label={label}
          aria-expanded={open}
        >
          <FiSearch aria-hidden="true" />
        </button>
        {open ? (
          <>
            <input
              ref={inputRef}
              type="search"
              value={value}
              onChange={(event) => onChange(event.target.value)}
              placeholder={placeholder}
              aria-label={label}
              className="h-full min-w-0 flex-1 border-0 bg-transparent pr-1 text-sm outline-none placeholder:text-slate-400"
            />
            <button
              type="button"
              onClick={close}
              className="inline-flex h-10 w-9 shrink-0 items-center justify-center text-slate-400 hover:text-slate-700"
              aria-label="Close search"
            >
              <FiX aria-hidden="true" />
            </button>
          </>
        ) : null}
      </div>
    </div>
  );
}
